<button class="button-general" (click)="clickDownload()">Download</button>